export const ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD = 'ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD'
export const ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD_PENDING =
  'ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD_PENDING'
export const ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD_FULFILLED =
  'ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD_FULFILLED'
export const ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD_REJECTED =
  'ONBOARDING_EMPLOYEES_WITH_EMAIL_LOAD_REJECTED'
